<template>
  <div>
    <vs-prompt title="Add new floorplan" @cancel="val = ''" @accept="accept" :active.sync="prompt" accept-text="Add" :is-valid="validForm">
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Floorplan name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input class="inputx w-full" v-model="name" />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["venueId"],
  emits: ["onAddedNew"],
  data() {
    return {
      name: "",
      prompt: false
    };
  },
  computed: {
    validForm() {
      return this.name !== "";
    }
  },
  methods: {
    show() {
      this.name = "";
      this.prompt = true;
    },
    async accept() {
      this.$vs.loading();

      var result = await this.$store.dispatch("pos/floorplan/createFloorplan", { name: this.name, venueId: this.venueId });

      this.$vs.notify({
        color: "green",
        title: `Floorplan created`,
        text: "Floorplan was successfully created"
      });

      this.$emit("onAddedNew", result);
      this.$vs.loading.close();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
